import { BoardUserActivityType } from '@/api/workspaceSettings/queries';
import type { BoardActivityItem } from './types';

const excludedTypes = new Set<number>([
    BoardUserActivityType.CardCopiedToClipboard,
    BoardUserActivityType.NotificationDismissed,
    BoardUserActivityType.IdeaPanelFiltersChanged,
    BoardUserActivityType.IdeaIsProcessedChanged,
    BoardUserActivityType.FeedbackIsProcessedChanged,
    BoardUserActivityType.StorymapCreatedByCopy,
    BoardUserActivityType.StorymapCreatedFromSample,
]);

const inboundIntegrationTypes = new Set<number>([
    BoardUserActivityType.CardUnlinkedByIntegratedTool,
    BoardUserActivityType.CardTitleChangedByIntegratedTool,
    BoardUserActivityType.CardDescriptionChangedByIntegratedTool,
    BoardUserActivityType.CardStatusChangedByIntegratedTool,
    BoardUserActivityType.CardEstimationChangedByIntegratedTool,
    BoardUserActivityType.CardReleaseChangedByIntegratedTool,
    BoardUserActivityType.ReleaseNameChangedByIntegratedTool,
    BoardUserActivityType.ReleaseReleasedByIntegratedTool,
    BoardUserActivityType.ReleaseUnreleasedByIntegratedTool,
    BoardUserActivityType.ReleaseArchivedByIntegratedTool,
    BoardUserActivityType.ReleaseReactivatedByIntegratedTool,
    BoardUserActivityType.ReleaseGoalChangedByIntegratedTool,
    BoardUserActivityType.ReleaseStartDateChangedByIntegratedTool,
    BoardUserActivityType.ReleaseReleaseDateChangedByIntegratedTool,
    BoardUserActivityType.ReleaseUnlinkedByIntegratedTool,
    BoardUserActivityType.CardReleaseRemovedByIntegratedTool,
]);

export function isRelevantBoardActivityForBadge(activity: BoardActivityItem): boolean {
    return !excludedTypes.has(activity.type);
}

export function shouldCountBoardActivityForBadge(activity: BoardActivityItem, currentUserIds: string | string[]): boolean {
    if (!isRelevantBoardActivityForBadge(activity)) {
        return false;
    }

    if (!isCurrentUserBoardActivity(activity, currentUserIds)) {
        return true;
    }

    return isMcpActivity(activity) || inboundIntegrationTypes.has(activity.type);
}

export function shouldFollowBoardActivityChange(activity: BoardActivityItem, currentUserIds: string | string[]): boolean {
    return !isCurrentUserBoardActivity(activity, currentUserIds) || isMcpActivity(activity);
}

export function isCurrentUserBoardActivity(activity: BoardActivityItem, currentUserIds: string | string[]): boolean {
    const ownUserIds = Array.isArray(currentUserIds) ? currentUserIds : [currentUserIds];
    return ownUserIds.includes(activity.userId);
}

export function isMcpActivity(activity: BoardActivityItem): boolean {
    return activity.externalToolName?.startsWith('mcp:') === true;
}
